import React from "react";
import "./Testimonials.css";

import {
  FaQuoteLeft,
  FaStar,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Indian India",
    company: "Business Owner",
    review:
      "I have collaborated with Yashvitech. They provided me effective software for my business requirements. Their team is highly professional and always available whenever support is needed.",
  },
  {
    name: "Ashutosh Singh",
    company: "S. R. ENTERPRISES",
    review:
      "I recently engaged with Yashvitech IT Solutions and I must say their professionalism, communication and quality of work exceeded my expectations.",
  },
  {
    name: "Tarishi Agrawal",
    company: "Freelancer",
    review:
      "They understood exactly what I needed and suggested the best solution. The entire process was smooth and delivered before the deadline.",
  },
  {
    name: "Kamal Kishore Agrawal",
    company: "Priyanshi Coalfeeder Pvt Ltd",
    review:
      "Yashvitech IT Solution Pvt Ltd provides excellent software for our company. It has improved our daily workflow and management.",
  },
  {
    name: "Yuvraj Sahu",
    company: "Independent Reviewer",
    review:
      "I look forward to watching Yashvitech IT Solution continue to grow. Their dedication towards customer satisfaction is truly impressive.",
  },
  {
    name: "Hariom Trading Company",
    company: "Client",
    review:
      "We are using Yashvitech software and it has become an important part of our business. Excellent service and timely support.",
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials-section">
      {/* Background Glow Effects */}
      <div className="testimonials-glow-1" />
      <div className="testimonials-glow-2" />

      {/* Section Header */}
      <div className="testimonials-header">
        <span className="testimonials-badge">CLIENT TESTIMONIALS</span>
        <p className="testimonials-subtitle">
          Trusted by startups, enterprises and businesses across India for
          Software Development, Website Design and Digital Marketing.
        </p>
      </div>

      {/* Testimonials Slider */}
      <Swiper
        className="testimonials-slider"
        modules={[Navigation, Pagination, Autoplay]}
        loop={true}
        speed={900}
        spaceBetween={30}
        centeredSlides={true} /* 👈 यह सेंटर कार्ड को एक्टिव रखने के लिए ज़रूरी है */
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        navigation={{
          nextEl: ".testimonials-next",
          prevEl: ".testimonials-prev",
        }}
        pagination={{
          el: ".testimonials-pagination",
          clickable: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 1.7, /* 👈 टैबलेट पर सेंटर कार्ड शानदार दिखेगा */
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3, /* 👈 डेस्कटॉप पर 3 कार्ड्स दिखेंगे और सेंटर वाला ज़ूम होगा */
            spaceBetween: 30,
          },
        }}
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="testimonials-card">
              {/* Quote Icon */}
              <FaQuoteLeft className="testimonials-quote" />

              {/* Star Ratings */}
              <div className="testimonials-stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>

              {/* Review Text */}
              <p className="testimonials-review">{item.review}</p>

              {/* Client Info */}
              <div className="testimonials-client">
                <div className="testimonials-avatar">
                  {item.name.charAt(0)}
                </div>
                <div className="testimonials-client-info">
                  <h3>{item.name}</h3>
                  <span>{item.company}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Side Arrow Controls & Pagination */}
      <button className="testimonials-prev" aria-label="Previous">
        <FaArrowLeft />
      </button>

      <div className="testimonials-controller">
        <div className="testimonials-pagination"></div>
      </div>

      <button className="testimonials-next" aria-label="Next">
        <FaArrowRight />
      </button>
    </section>
  );
}